import { render, staticRenderFns } from "./HospitalTwo.vue?vue&type=template&id=6eb7493e&scoped=true&"
import script from "./HospitalTwo.vue?vue&type=script&lang=js&"
export * from "./HospitalTwo.vue?vue&type=script&lang=js&"
import style0 from "./HospitalTwo.vue?vue&type=style&index=0&id=6eb7493e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb7493e",
  null
  
)

export default component.exports